import React from "react";
import "../../App.css";
import ReactPlayer from "react-player";

function Techfpga() {
  return (
    <div className="reel">
      <>
        <ReactPlayer
          url="https://www.youtube.com/watch?v=suAzZTa58SY"
          width="100%"
          height="100%"
          controls={true}
        />
      </>
    </div>
  );
}

export default Techfpga;
